module.exports = __webpack_public_path__ + "static/media/pos_order_details.454720c8.jpg";